import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
import anatomy from './images/anatomy.png';
import doPosition from './images/do-position.png';
import dontPosition from './images/dont-position.png';
import doAlign from './images/do-align.png';
import dontAlign from './images/dont-align.png';
import doUseSparingly from './images/do-use-sparingly.png';
import dontStack from './images/dont-stack.png';
import doLength from './images/do-length.png';
import dontLength from './images/dont-length.png';
import doBG from './images/do-bg.png';
import dontBG from './images/dont-bg.png';
import doLeadingVisual from './images/do-leading-visual.png';
import dontLeadingVisual from './images/dont-leading-visual.png';
import doLeadingVisualColor from './images/do-leading-visual-color.png';
import dontLeadingVisualColor from './images/dont-leading-visual-color.png';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Use breakout banners to promote important information and actions in-between blocks of content.`}</p>
    <p>{`Whereas the CTA banner is intended to redirect users to their respective conversion outlets, links in the breakout banner should only cross-link to supporting content.`}</p>
    <h2>{`Anatomy`}</h2>
    <img src={anatomy} alt="Breakout banner with location-based annotations for heading, description, leading visual and link groups" />
    <h2>{`Usage`}</h2>
    <p>{`Breakout banners should be used in the middle of a page to break up long blocks of content. Avoid using the breakout banner at the beginning or towards the end of a page.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src={doPosition} alt="" />
    <Caption mdxType="Caption">Use breakout banners to break up longer pages.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src={dontPosition} alt="" />
    <Caption mdxType="Caption">
      Don't use the breakout banner too early or late in the page (E.g. near the
      footer). Prefer CTA banner in case of the latter. Also avoid placing the
      breakout banner too close to related components like the CTA banner.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Alignment`}</h3>
    <p>{`The breakout banner content can be aligned to the start or center of the parent element, with the former being the default. Use the center alignment if context calls for it.`}</p>
    <p>{`E.g. Use center alignment if the breakout banner is placed between two sections that are also centered aligned to avoid breaking the visual flow.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src={doAlign} alt="" />
    <Caption mdxType="Caption">Use start alignment when possible.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src={dontAlign} alt="" />
    <Caption mdxType="Caption">
      Don't use start alignment when adjacent content is center aligned.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Use sparingly`}</h3>
    <p>{`Breakout banners should be used sparingly, at most once per page. This is to avoid diluting the impact of the spotlighted content or links in the context of the wider page.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src={doUseSparingly} />
    <Caption mdxType="Caption">Use breakout banner sparingly.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src={dontStack} />
    <Caption mdxType="Caption">
      Don't stack multiple breakout banners, prefer Bento instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Use concise headings`}</h3>
    <p>{`Both heading and optional descriptions in the breakout banner should be short and focussed. Heading should be not be longer than 3 lines, and description should be no longer than 3-4 lines.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src={doLength} />
    <Caption mdxType="Caption">Use concise, but impactful heading and description text.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src={dontLength} />
    <Caption mdxType="Caption">
      Don't use longer form content in the heading or description. Consider
      using Bento as an alternative.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Background visuals`}</h3>
    <p>{`Background images should be abstract and low fidelity to not compete with the foreground text.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src={doBG} />
    <Caption mdxType="Caption">
      Use approved wallpapers that provide space and contrast with the
      foreground text.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src={dontBG} />
    <Caption mdxType="Caption">Don't use images of people's faces, real objects, etc.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Leading visuals`}</h3>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src={doLeadingVisual} />
    <Caption mdxType="Caption">
      Use logos or icons that are related to the adjacent banner content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src={dontLeadingVisual} />
    <Caption mdxType="Caption">
      Don't use decorative imagery as a leading visual. Use the background image
      to apply decoration.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src={doLeadingVisualColor} />
    <Caption mdxType="Caption">
      Use monochrome colors, which correspond to the text color of the current,
      active color mode.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src={dontLeadingVisualColor} />
    <Caption mdxType="Caption">Don't use full color visuals.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To highlight important information and actions towards the end of a page.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      